import React from 'react';
import { connect } from 'react-redux'
import { setInfoKey, addBeneficiary } from '../../api/information-collection/actions'
import { fetchNationalRegistryNamespaced } from '../../api/national-registry/actions'

const kennitala = require('kennitala')


class DeathbenefitsBeneficiaryModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            search: ''
        }

        this.addDeathbenefitsBeneficiary = this.addDeathbenefitsBeneficiary.bind(this)
        this.buttonDisabled = this.buttonDisabled.bind(this)
        this.handleSSN = this.handleSSN.bind(this)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.nationalRegistryNamespaced && nextProps.nationalRegistryNamespaced[nextProps.id] && nextProps.nationalRegistryNamespaced[nextProps.id].data.find(item => item.OrgId === kennitala.clean(prevState.search))) {
            return { beneficiaryObj: nextProps.nationalRegistryNamespaced[nextProps.id].data.find(item => item.OrgId === kennitala.clean(prevState.search)) };
        }
        else return null;
    }

    componentDidMount(){
        initialInputState();
        let that = this;
        $('#' + this.props.id).on('hidden.bs.modal', function () {
            that.clearModal();
        });
    }

    componentDidUpdate(){
        initialInputState();
    }

    handleSSN(event) {
        this.setState({
            search: event.target.value
        })
        let onlyLookup = true;

        if (kennitala.isValid(event.target.value)) {
            this.props.dispatch(fetchNationalRegistryNamespaced(kennitala.clean(event.target.value), onlyLookup, this.props.id))
        }
    }

    clearModal(){
        setTimeout(() => {
            delete this.state.beneficiaryObj;
            this.setState({
                ...this.state,
                search: '',
            });
        }, 500)
    }


    addDeathbenefitsBeneficiary(){
        let beneficiaryObj = this.props.nationalRegistryNamespaced[this.props.id].data.find(item => item.OrgId === kennitala.clean(this.state.search));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName, value: "40" }, this.props.customerId));
        this.props.dispatch(addBeneficiary({ key: this.props.fieldName + "OrgId", value: beneficiaryObj.OrgId}, this.props.customerId));
    }

    buttonDisabled() {
        if (!this.state.beneficiaryObj) {
            return true
        }
        if (this.state.beneficiaryObj && this.state.beneficiaryObj.OrgId === this.props.customerId) {
            return true
        }
    }

    render() {

        return (


            <div className="modal payer-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className={this.state.beneficiaryObj && this.state.beneficiaryObj.OrgId ? "payer-form ssn-confirm" : "payer-form"} id="payer-form">
                                <div className="row">
                                    <div className="form-group">
                                        <input id="quote-ssn" className="form-control" placeholder=" " value={this.state.search} type="text" onChange={this.handleSSN.bind(this)} autoFocus />
                                        <label htmlFor="quote-ssn">Kennitala</label>
                                    </div>
                                    <div className="name-container">
                                        {this.state.beneficiaryObj && <div className="name">{this.state.beneficiaryObj.Name}</div>}
                                    </div>
                                </div>
                                
                                <button disabled={this.buttonDisabled() } className="btn btn-primary" type="button" onClick={this.addDeathbenefitsBeneficiary} data-dismiss="modal">Vista rétthafa dánarbóta</button>
                            </div>
                        </div>
                        
                            {this.state.beneficiaryObj && this.state.beneficiaryObj.OrgId === this.props.customerId &&
                                <div className="modal-footer">
                                    Rétthafi má ekki vera sami og tryggingaþegi
                                </div>
                            }
                    </div>
                </div>
            </div>
        )
    }
}

DeathbenefitsBeneficiaryModal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        nationalRegistryNamespaced: {},
    }

    f.nationalRegistryNamespaced = (state.nationalRegistryNamespaced === undefined) ? {} : state.nationalRegistryNamespaced

    return f;
}

export default connect(mapStateToProps)(DeathbenefitsBeneficiaryModal);